import { FC } from 'react';
import { Stack, Typography } from '@mui/material';

type Props = {
  items: string[];
};

/**
 * @summary Маркированный список с использованием mui компонентов.
 *
 * @param items - Набор строк для отображения.
 */
export const BulletedList: FC<Props> = ({ items }) => (
  <Stack
    component="ul"
    sx={{
      m: 0,
      pl: 3,
    }}
  >
    {items.map((item, index) => (
      <Typography variant="body2" component="li" key={index}>
        {item}
      </Typography>
    ))}
  </Stack>
);
